import React from "react";
import { Divider } from "antd";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import media from "../../../media";

const DeletedAuditDetails = ({
  auditFormInput,
  fatalNotFatalInfo,
  timeStampsDetails,
  qualityScore,
  auditorProfileImage,
  agentProfileImage,
}) => {
  const auditDetailsFormInput = auditFormInput && auditFormInput;
  return (
    <>
      <h3>Audit Details</h3>

      {auditDetailsFormInput &&
        Object.entries(auditDetailsFormInput).map(([key, item], i) => (
          <div
            className="align-items-center d-flex justify-content-between mt-4"
            key={i}
          >
            {key === "Reason for duplicate Transaction ID" && item.value === "" ? (
              <></>
            ) : (
              <>
                <span className="text11 audit-details-left color-grey cusAuditCol">
                {item?.icon && (
                  <img src={media[item.icon]?.svg} alt="icon" />
                )}
                {key && key.charAt(0)?.toUpperCase() + key.slice(1)}
                </span>
                <span className="cusAuditCol">
                  
                  {key === "Stage" ? (
                    <img
                      src={
                        item.value === "Audit Completed"
                          ? "../audited.PNG"
                          : item.value === "Audit Pending"
                          ? "../pending.png"
                          : item.value === "Accepted"
                          ? "../completed.png"
                          : "../disputed.png"
                      }
                      style={{ width: "17px" }}
                      alt="logo"
                    />
                  ) : key === "Auditor" ? (
                    <img
                      className="auditProfileImage"
                      src={
                        auditorProfileImage?.profilePicUrl
                          ? auditorProfileImage?.profilePicUrl
                          : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
                      }
                      alt={auditorProfileImage?.name}
                    />
                  ) : key === "agent" ? (
                    <img
                      className="auditProfileImage"
                      src={
                        agentProfileImage?.profilePicUrl
                          ? agentProfileImage?.profilePicUrl
                          : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
                      }
                      alt={agentProfileImage?.name}
                    />
                  ) : (
                    ""
                  )}

                  <span className="text11 audit-details-left">
                    {key === "Audit Score"
                      ? secureLocalStorage.getItem("auditScore")
                        ? secureLocalStorage.getItem("auditScore") + "%"
                        : qualityScore + "%"
                      : key === "Transaction Date"
                      ? moment(item.value).format("DD-MM-YY")
                      : key === "Audit Date and Time"
                      ? moment(item.value).format("DD-MM-YY HH:MM A")
                      : item.value &&
                        item.value?.charAt(0)?.toUpperCase() + item.value.slice(1)}
                  </span>
                </span>
              </>
            )}
          </div>
        ))}

      {/* {fatalNotFatalInfo &&
        Object.entries(fatalNotFatalInfo).map(([key, value], i) => (
          <div
            className="align-items-center d-flex justify-content-between mt-4"
            key={i}
          >
            <span className="text11 audit-details-left color-grey">
              {value?.icon && (
            <img
              src={media[value.icon]?.svg}
              alt={key}
              className="auditIcon"
            />
          )}
          {key === "notFatal"
                ? "Not Fatal"
                : key && key.charAt(0).toUpperCase() + key.slice(1)}
            </span>
          <span className="text11 audit-details-left">{value?.value}</span>
          </div>
        ))} */}

        {fatalNotFatalInfo &&
        Object.entries(fatalNotFatalInfo).map(([key, value], i) => {
          const label = key === "notFatal" ? "Not Fatal" : "Fatal";

          // Decide icon based on key (text)
          const iconName =
            key === "notFatal" ? "auditNoFatel" : "auditFatel";

          return (
            <div
              className="align-items-center d-flex justify-content-between mt-4"
              key={i}
            >
              {/* Left side: Icon + Text */}
              <span className="text11 audit-details-left color-grey d-flex align-items-center cusAuditCol">
                <img
                  src={media[iconName]?.svg}
                  alt={label}
                  className="auditIcon"
                />
                <span>{label}</span>
              </span>

              {/* Right side: Value */}
              <span className="text11 audit-details-right cusAuditCol">
                {value?.value ?? "-"}
              </span>
            </div>
          );
        })}
      <Divider />
      {timeStampsDetails && (
        <span className="text11 audit-details-left">Time Stamps</span>
      )}
      {timeStampsDetails &&
        Object.entries(timeStampsDetails).map(([key, value], i) =>
          value !== null ? (
            <div
              className="align-items-center d-flex justify-content-between mt-4"
              key={i}
            >
              <span className="text11 audit-details-left color-grey cusAuditCol">
                 <img
                  src={media.auditCalendar.svg}
                />{key &&
                  key.charAt(0).toUpperCase() + key.slice(1).replace("A", " A")}
              </span>
              <span className="cusAuditCol">
                <span className="text11 audit-details-left">
                  {moment(value).format("DD-MM-YY HH:mm A")}
                </span>
              </span>
            </div>
          ) : (
            ""
          )
        )}
    </>
  );
};

export default DeletedAuditDetails;
